require("!!/Users/sergeyk/git/wdf/node_modules/mocha-loader/node_modules/script-loader/addScript.js")(require("!!/Users/sergeyk/git/wdf/node_modules/mocha-loader/node_modules/script-loader/node_modules/raw-loader/index.js!/Users/sergeyk/git/wdf/node_modules/mocha/mocha.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha-loader/~/script-loader!./~/mocha/mocha.js
 ** module id = 6
 ** module chunks = 0
 **/